"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var utils_1 = require("./utils");
var const_1 = require("./const");
var createTableCellPlugin = function (props) {
    var TableCellItem = /** @class */ (function (_super) {
        __extends(TableCellItem, _super);
        function TableCellItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = const_1.NODE_NAME.TABLE_CELL;
            _this.content = 'block+';
            _this.attrs = utils_1.createCellAttrs(props.defaultCellWidth, props.cellAttributes);
            _this.tableRole = 'cell';
            _this.isolating = true;
            _this.parseDOM = [
                {
                    tag: 'td',
                    getAttrs: function (dom) { return utils_1.getCellAttrs(dom, props.cellAttributes); }
                },
                {
                    tag: 'th',
                    priority: 20,
                    getAttrs: function (dom) { return utils_1.getCellAttrs(dom, props.cellAttributes); }
                }
            ];
            _this.toDOM = function (node) {
                return ['td', utils_1.setCellAttrs(node, props.cellAttributes), 0];
            };
            return _this;
        }
        return TableCellItem;
    }(core_utilities_1.Block));
    return /** @class */ (function (_super) {
        __extends(TableCellPlugin, _super);
        function TableCellPlugin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Schema = TableCellItem;
            return _this;
        }
        return TableCellPlugin;
    }(core_utilities_1.SylPlugin));
};
exports.createTableCellPlugin = createTableCellPlugin;
//# sourceMappingURL=table-cell.js.map